
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Home',

    metaInfo: { title: 'Accueil' },

    extends: View,

    mixins: [
      LoadSections([
        'home-carousel',
        'why-impot-ad',
        // 'contact-us',
        // 'affiliates',
        // 'social-media',
        // 'keep-in-touch',
        //'newsletter',
        // 'pro-features',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'home',
      },
    },
  }
</script>
